export const AlertMessageDefault = () => {
  return (
    <>
      Oops! It looks like something went wrong. Please check your original invitation email for the
      link to continue.
    </>
  );
};

export default AlertMessageDefault;
